import React, {Component} from 'react';
import onUserActivity from '../actions/user-activity';
import store from '../store';

const windowEventsName = [
    'touchmove',
    'mousemove',
    'click',
    'touch'
];

const USER_ACTIVITY_THROTTLING_INTERVAL = 5000;
let inactivitySelfDestroyingTimeout = null;

function performEventCallbackIfInactivityTimeoutIsNotPresent(callback) {
    if (inactivitySelfDestroyingTimeout == null) {
        callback();
        inactivitySelfDestroyingTimeout = setTimeout(() => inactivitySelfDestroyingTimeout = null, USER_ACTIVITY_THROTTLING_INTERVAL);
    }
}

const withUserActivityTracker = Component => {
    return class UserActivityTracker extends Component {

        componentWillUnmount() {
            for (const windowEventName in windowEventsName) {
                window.removeEventListener(windowEventName, this.handleUserActivityEvent);
            }
        }

        componentDidMount() {
            for (const windowEventName of windowEventsName) {
                window.addEventListener(windowEventName, this.handleUserActivityEvent);
            }
        }

        handleUserActivityEvent = () => {
            performEventCallbackIfInactivityTimeoutIsNotPresent(this.dispatchUserActivityToStore);
        };

        dispatchUserActivityToStore = () => {
            store.dispatch(onUserActivity(store.getState()));
        }
    }
};

export default withUserActivityTracker;


// WEBPACK FOOTER //
// ./src/decorators/UserActivityTracker.js